import React from 'react';
import { Spinner, Badge } from 'react-bootstrap';
import { FaBuilding } from 'react-icons/fa';
import { useDetailSort } from '../hooks/useDetailSort';
import { ThSort, DetailPager, DetailSectionHeader } from '../shared/index';
import { detailSectionCard } from '../utils/constants';
import { fmt, fmtDate } from '../utils/helpers';
import { exportExcel, rowsToHtml, copyHtmlToClipboard } from '../utils/exports';

const cols = [
  { key: 'id',          label: 'Contrat' },
  { key: 'datePn',      label: 'Date PN' },
  { key: 'numDoss',     label: 'N° Dossier' },
  { key: 'description', label: 'Description' },
  { key: 'projet',      label: 'Projet' },
  { key: 'type',        label: 'Type' },
  { key: 'tranche',     label: 'Tranche' },
  { key: 'superficie',  label: 'Sup. m²',  right: true },
  { key: 'prixM',       label: 'Prix/m²',  right: true },
  { key: 'prixNet',     label: 'Prix Net',  right: true },
  { key: 'commercial',  label: 'Commercial' },
  { key: 'clients',     label: 'Client(s)' },
];

const DetailTablePn = ({ data, loading, open, setOpen }) => {
  const { visible, sortKey, asc, handleSort, page, setPage, totalPages, total } = useDetailSort(data);

  return (
    <div style={detailSectionCard}>
      <DetailSectionHeader
        title="Détail Passages Notaire" icon={<FaBuilding size={13} />}
        color="#ce93d8" count={data.length} loading={loading} open={open} setOpen={setOpen}
        onExport={() => exportExcel(data.map(r => ({
          'ID Contrat': r.id, 'Date PN': r.datePn, 'N° Dossier': r.numDoss,
          'Description': r.description, 'Projet': r.projet, 'Type': r.type, 'Tranche': r.tranche,
          'Superficie': r.superficie, 'Prix/m²': r.prixM, 'Prix Net': r.prixNet,
          'Commercial': r.commercial, 'Client(s)': r.clients,
        })), 'detail-pn')}
        onCopy={() => { const { html, plain } = rowsToHtml(data.map(r => ({
          'ID': r.id, 'Date PN': fmtDate(r.datePn), 'N° Doss': r.numDoss || '',
          'Description': r.description || '', 'Projet': r.projet, 'Type': r.type || '',
          'Tranche': r.tranche || '', 'Prix Net': fmt(r.prixNet),
          'Commercial': r.commercial || '', 'Clients': r.clients || '',
        })), 'purple'); copyHtmlToClipboard(html, plain); }}
      />
      {open && (
        <>
          {loading ? (
            <div style={{ padding: 30, textAlign: 'center' }}><Spinner /></div>
          ) : data.length === 0 ? (
            <div style={{ padding: 30, textAlign: 'center', color: '#aaa', fontSize: '0.85rem' }}>Aucun passage notaire sur la période</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.78rem' }}>
                <thead><tr>{cols.map(c => <ThSort key={c.key} label={c.label} field={c.key} sortKey={sortKey} asc={asc} onSort={handleSort} right={c.right} />)}</tr></thead>
                <tbody>
                  {visible.map((row, i) => (
                    <tr key={row.id} style={{ borderBottom: '1px solid #f0ebe4', background: i % 2 === 0 ? '#fff' : '#fdfaf7' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f9f3ed'}
                      onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#fdfaf7'}>
                      <td style={{ padding: '5px 8px', whiteSpace: 'nowrap' }}>
                        <a href={`https://shems.ngrok.io/consultation/${row.id}`} target="_blank" rel="noreferrer"
                          style={{ color: '#6d4e36', fontWeight: 700, textDecoration: 'none', borderBottom: '1px dashed #c8a882' }}>#{row.id}</a>
                      </td>
                      <td style={{ padding: '5px 8px', whiteSpace: 'nowrap' }}>{fmtDate(row.datePn)}</td>
                      <td style={{ padding: '5px 8px', color: '#6d4e36', fontWeight: 600 }}>{row.numDoss || '—'}</td>
                      <td style={{ padding: '5px 8px', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{row.description || '—'}</td>
                      <td style={{ padding: '5px 8px', fontWeight: 500 }}>{row.projet}</td>
                      <td style={{ padding: '5px 8px' }}><Badge bg="none" style={{ background: '#f9f5f1', color: '#6d4e36', border: '1px solid #e8ddd4', fontSize: '0.65rem' }}>{row.type || '—'}</Badge></td>
                      <td style={{ padding: '5px 8px', color: '#666' }}>{row.tranche || '—'}</td>
                      <td style={{ padding: '5px 8px', textAlign: 'right' }}>{row.superficie != null ? fmt(row.superficie) : '—'}</td>
                      <td style={{ padding: '5px 8px', textAlign: 'right', color: '#555' }}>{row.prixM != null ? fmt(row.prixM) : '—'}</td>
                      <td style={{ padding: '5px 8px', textAlign: 'right', fontWeight: 700, color: '#1b5e20' }}>{fmt(row.prixNet)}</td>
                      <td style={{ padding: '5px 8px', color: '#555' }}>{row.commercial || '—'}</td>
                      <td style={{ padding: '5px 8px', color: '#444', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{row.clients || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <DetailPager page={page} setPage={setPage} totalPages={totalPages} total={total} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default DetailTablePn;
